import { config } from '../config';
import { constructQueryParams, generateQueryString, isValidUUID, makeApiRequest_AppJson, makeApiRequest_formData, makeApiRequest_Text } from './common-apiService';

// FRAMEWORKS

// the following function will return depending on the variable frameworkSuitte (generic, iot, vertical, partner)
// the base URL for the frameworks
const getFrameworksBaseURL = (frameworkSuite) => {
    switch (frameworkSuite) {
        case 'generic':
            return `${config.baseB2B_URL}/b2b/genericfw`;
        case 'iot':
            return `${config.baseB2B_URL}/b2b/iot`;
        case 'vertical':
            return `${config.baseB2B_URL}/b2b/vertical`;
        case 'partner':
            return `${config.baseB2B_URL}/b2b/partners`;
        case 'software':
            return `${config.baseB2B_URL}/b2b/software`;
        default:
            return null;
    }
}

export const fetchGitFrameworksData = async (frameworkSuite) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchFrameworksData = async (frameworkSuite, accessToken, addImages = true, addLevel1s = true, addLevel1sImages = true) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/?addImages=${addImages}&addLevel1s=${addLevel1s}&addLevel1sImages=${addLevel1sImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchFrameworkData = async (frameworkSuite, frameworkId, accessToken, depth, fwAddImages, levelNsAddImages) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}?depth=${depth}&fwAddImages=${fwAddImages}&levelNsAddImages=${levelNsAddImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchFrameworksDataPaged = async (frameworkSuite, page, pageSize, accessToken, countB2bIndicators) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/paged?page=${page}&size=${pageSize}&countB2bIndicators=${countB2bIndicators}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchLevelNsData = async (frameworkSuite, frameworkId, levelId, accessToken, depth, fetchIndicatorDTOs, levelNsAddImages) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelId}?depth=${depth}&fetchIndicatorDTOs=${fetchIndicatorDTOs}&levelNsAddImages=${levelNsAddImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const getFrameworkImagePathWithAPIKey = async (frameworkSuite, frameworkId, localeCode = null) => {
    let url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/imagePath`;
    if (localeCode) {
        url += `?localeCode=${localeCode}`;
    }
    const headers = {
        'X-B2B-API-Key': config.b2bGenericFwsAPIKey,
    };
    return makeApiRequest_Text(url, 'GET', headers);
}

export const getLevelNImagePath = async (frameworkSuite, frameworkId, levelId, localeCode = null, accessToken) => {
    let url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelId}/imagePath`;
    if (localeCode) {
        url += `?localeCode=${localeCode}`;
    }
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const getLevelNImagePathWithAPIKey = async (frameworkSuite, frameworkId, levelId, localeCode = null, imageLabel = null) => {
    let url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelId}/imagePath`;
    const queryParams = constructQueryParams({ localeCode, imageLabel });
    url += queryParams;
    const headers = {
        'X-B2B-API-Key': config.b2bGenericFwsAPIKey,
    };
    return makeApiRequest_Text(url, 'GET', headers);
}

export const getLevelN_NameWithAPIKey = async (frameworkSuite, frameworkId, levelId, localeCode = null) => {
    let url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelId}/name`;
    if (localeCode) {
        url += `?localeCode=${localeCode}`;
    }
    const headers = {
        'X-B2B-API-Key': config.b2bGenericFwsAPIKey,
    };
    return makeApiRequest_Text(url, 'GET', headers);
}

export const fetchGenericFrameworksB2BIndicatorsData = async (frameworkSuite, page, pageSize, frameworkId, searchFields, accessToken, organizationUuid, plansUsage = true, genericFwUsage = true) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/b2bIndicators/paged?page=${page}&size=${pageSize}&${generateQueryString(searchFields)}&plansUsage=${plansUsage}&genericFwUsage=${genericFwUsage}&organizationUuid=${organizationUuid}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const uploadFrameworkImage = async (frameworkSuite, frameworkId, image, accessToken, urlParams = null) => {
    const params = generateQueryString(urlParams);
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/image?${params.toString()}`;
    const formData = new FormData();
    formData.append("image", image);
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const deleteFrameworkImage = async (frameworkSuite, frameworkId, accessToken, urlParams = null) => {
    const params = generateQueryString(urlParams);
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/image?${params.toString()}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const uploadLevelNImage = async (frameworkSuite, frameworkId, levelNId, image, accessToken, urlParams = null) => {
    const params = generateQueryString(urlParams);
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelNId}/image?${params.toString()}`;
    const formData = new FormData();
    formData.append("image", image);
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const deleteLevelNImage = async (frameworkSuite, frameworkId, levelNId, accessToken, urlParams = null) => {
    const params = generateQueryString(urlParams);
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelNId}/image?${params.toString()}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const addB2BIndicator = async (frameworkSuite, frameworkId, levelNId, indicatorUUID, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelNId}/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers);
}

export const deleteB2BIndicator = async (frameworkSuite, frameworkId, levelNId, indicatorUUID, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelNId}/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const plansRelationToFws = async (frameworkSuite, plansUUIDs, includeImages = true, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/plansRelationToFws?includeImages=${includeImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, plansUUIDs);
}

export const areasRelationToFws = async (frameworkSuite, areaDTOs, includeImages = true, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/areasRelationToFws?includeImages=${includeImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, areaDTOs);
}

export const indicatorsRelationToFws = async (frameworkSuite, indicatorsUUIDs, includeImages = true, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/indicatorsRelationToFws?includeImages=${includeImages}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, indicatorsUUIDs);
}

export const calculatePlansImpactOnFramework = async (frameworkSuite, frameworkId, plansUUIDs, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/plansImpact`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, plansUUIDs);
}

export const calculateAreasImpactOnFramework = async (frameworkSuite, frameworkId, planAreasDTOs, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/areasImpact`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, planAreasDTOs);
}

export const calculateAreaIndicatorsImpactOnFramework = async (frameworkSuite, frameworkId, areaIndicators, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/areaIndicatorsImpact`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, areaIndicators);
}

export const getNonStandardLevelNs = async (frameworkSuite, frameworkId, accessToken, levelNsAddImages = false) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/nonStandard${levelNsAddImages ? '?levelNsAddImages=true' : ''}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const addCustomIndicatorToLevelN = async (frameworkSuite, frameworkId, levelNId, indicatorUUIDs, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/${levelNId}/addCustomIndicators`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, indicatorUUIDs);
}

export const addCustomIndicatorToMultipleLevelNs = async (frameworkSuite, frameworkId, indicatorUUID, b2bIndicatorDTOs, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/addCustom/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, b2bIndicatorDTOs);
}

export const getIndicatorLevelNs = async (frameworkSuite, frameworkId, indicatorUUID, accessToken) => {
    const url = `${getFrameworksBaseURL(frameworkSuite)}/${frameworkId}/indicator/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}